angular.module('jv.MyAccount.EditPersonalTemplate.Controller', [
    'jv.Common.Directives.jvTinymce',
    'jv.Common.Modal',
    'jv.Common.Directives.ShowPosition',
    'jv.Common.Directives.HideOnBlur',
    'ngStorage'
])
.controller('editPersonalTemplateController', [
    '$scope', '$rootScope', 'myAccount', '$routeParams', '$location', '$q', '$localStorage', '$timeout',
    function($scope, $rootScope, myAccount, $routeParams, $location, $q, $localStorage, $timeout) {
        var confirmDeferred;
        var tokenPromise = myAccount.getTokens();
        $scope.state = {
            template: {
                name: '',
                subject: '',
                body: ''
            },
            error: {},
            modals: {},
            tokens: []
        };
        if (window.tinyMCE) {
            window.tinyMCE.remove();
        }
        $rootScope.breadcrumbsConfig.links.unshift({
            linkText: i18n['EMAIL_TEMPLATES'],
            link: $scope.jvUrls.admin+'/myaccount/profile.html#/emailTemplates'
        });
        $rootScope.breadcrumbsConfig.links.unshift({
            linkText: i18n['EDIT_TEMPLATE']
        });
        if ($routeParams.id !== 'new') {
            myAccount.getEmailTemplate($routeParams.id).then(function(res) {
                $scope.state.template = res.data.userEmailTemplate;
                if (!$scope.state.template) {
                    $scope.state.error.templateNotFound = true;
                }
                $scope.flags.loading = false;
            }, function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            });
        }
        else {
            ['name', 'subject', 'body'].forEach(function(prop) {
                if ($routeParams[prop]) {
                    $scope.state.template[prop] = $routeParams[prop];
                }
            });
            $scope.flags.loading = false;
        }

        tokenPromise.then(function(res) {
            $scope.state.tokens = res.data.userEmailTemplateTokens.map(function(token) {
                return {
                    name: token.key,
                    onClick: function() {
                        var tokenSpace = token.value + ' ';
                        var end;
                        if (!$scope.state.subjectCaretPosition) {
                            $scope.state.subjectCaretPosition = {
                                start: $scope.state.template.subject.length,
                                end: $scope.state.template.subject.length
                            };
                        }
                        $scope.state.template.subject = insertToken(tokenSpace, $scope.state.template.subject, $scope.state.subjectCaretPosition);
                        end = $scope.state.subjectCaretPosition.start + tokenSpace.length;
                        $scope.state.subjectCaretPosition.start = end;
                        $scope.state.subjectCaretPosition.end = end;
                        $scope.state.showSubjectTokenDropdown = false;
                    }
                };
            });
        });

        function goBack() {
            $location.path('/emailTemplates');
            $location.search('');
        }

        function confirmDelete() {
            confirmDeferred = $q.defer();
            $scope.state.modals.confirmDelete = true;
            return confirmDeferred.promise;
        }

        function insertToken(token, string, selection) {
            return string.substring(0, selection.start) + token + string.substring(selection.end, string.length);
        }

        $scope.deleteTemplate = function() {
            confirmDelete().then(function() {
                $scope.flags.loading = true;
                return myAccount.deleteEmailTemplate($scope.state.template).then(function() {
                    if ($localStorage.currentTemplatePageCount) {
                        $localStorage.currentTemplatePageCount = $localStorage.currentTemplatePageCount - 1;
                    }
                    // force digest so localstorage saves
                    $timeout(function(){
                        goBack();
                    });
                }, function() {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                    return $q.reject();
                });
            }).finally(function() {
                $scope.state.modals.confirmDelete = false;
                $scope.flags.loading = false;
            });
        };

        $scope.deleteConfirm = function() {
            confirmDeferred.resolve();
        };

        $scope.deleteCancel = function() {
            confirmDeferred.reject();
        };

        $scope.saveTemplate = function() {
            $scope.flags.loading = true;
            myAccount.saveEmailTemplate($scope.state.template).then(function() {
                goBack();
            }, function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }).finally(function() {
                $scope.flags.loading = false;
            });
        };

        $scope.addPersonalizeMenu = function(editor) {
            editor.ui.registry.addMenuButton('personalize', {
                text: i18n['PERSONALIZE'],
                fetch: function(callback) {
                    tokenPromise.then(function(res) {
                        var items = res.data.userEmailTemplateTokens.map(function(token) {
                            return {
                                type: 'menuitem',
                                text: token.key,
                                onAction: function() {
                                    editor.insertContent(token.value + ' ');
                                }
                            };
                        });
                        callback(items);
                    });
                }
            });
        };

        $scope.cancelSave = function() {
            goBack();
        };
    }
])
.directive('jvTrackCaretPosition', [
    '$timeout',
    function($timeout) {
        return {
            scope: {
                position: '=jvTrackCaretPosition',
                focusOnClick: '@'
            },
            link: function(scope, element) {
                angular.element(scope.focusOnClick).on('click', function() {
                    element[0].focus();
                });
                element.on('blur focus', function() {
                    $timeout(function(){
                        scope.position = {
                            start: element[0].selectionStart,
                            end: element[0].selectionEnd
                        };
                    });
                });
                scope.$watch('position', function(val) {
                    if (val) {
                        $timeout(function() {
                            if (element[0].selectionStart !== val.start || element[0].selectionEnd !== val.end) {
                                element[0].focus();
                                element[0].selectionStart = val.start;
                                element[0].selectionEnd = val.end;
                            }
                        }, 10, false); // wait for input value to be updated and don't trigger digest
                    }
                }, true);
            }
        };
    }
]);